interface Props {
  value?: number | boolean;
}

const BooleanLabel: React.FC<Props> = ({ value }) => {
  return (
    <span style={{ color: value ? "#22c55e" : "#ef4444" }}>
      {value ? "✔" : "✖"}
    </span>
  );
};

export default BooleanLabel;
